import { Unit } from '@interfaces/singlePublicBoat';
import { ltToT } from '@utils/UnitHandler';
import convert from 'convert-units';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSettings } from 'services/hooks';

type Props = {
  value: number;
  unit: Unit;
};

const UnitDetail: React.FC<Props> = ({ value, unit }) => {
  const { formatMessage } = useIntl();
  const { getSettingByKey } = useSettings();

  if (value === null) {
    return <>-</>;
  }

  const f = (id: string): string => formatMessage({ id });

  if (getSettingByKey('unit') === 'imperial') {
    return (
      <>
        {value.toLocaleString(undefined, { maximumFractionDigits: 2 })} {f(`unit_metric.imperial.${unit}`)}
      </>
    );
  }

  switch (unit) {
    case 'mph':
      return (
        <>
          {convert(value).from('m/h').to('km/h')?.toLocaleString(undefined, { maximumFractionDigits: 2 })}{' '}
          {f('unit_metric.metric.kmh')}
        </>
      );

    case 'ft':
      return (
        <>
          {convert(value).from('ft').to('m')?.toLocaleString(undefined, { maximumFractionDigits: 2 })}{' '}
          {f('unit_metric.metric.m')}
        </>
      );

    case 'lb':
      return (
        <>
          {convert(value).from('lb').to('kg')?.toLocaleString(undefined, { maximumFractionDigits: 2 })}{' '}
          {f('unit_metric.metric.kg')}
        </>
      );

    case 'lt':
      return (
        <>
          {ltToT(value)?.toLocaleString()} {f('unit_metric.metric.t')}
        </>
      );

    case 'sq.ft':
      return (
        <>
          {convert(value).from('ft2').to('m2')?.toLocaleString(undefined, { maximumFractionDigits: 2 })}{' '}
          {f('unit_metric.metric.sq.m')}
        </>
      );

    case 'gallon':
      return (
        <>
          {convert(value).from('gal').to('l')?.toLocaleString(undefined, { maximumFractionDigits: 2 })}{' '}
          {f('unit_metric.metric.liter')}
        </>
      );

    case 'knots':
      return (
        <>
          {convert(value).from('knot').to('km/h')?.toLocaleString(undefined, { maximumFractionDigits: 2 })}{' '}
          {f('unit_metric.metric.kmh')}
        </>
      );

    default:
      return (
        <>
          {value?.toLocaleString(undefined, { maximumFractionDigits: 2 })} {f(`unit_metric.imperial.${unit}`)}
        </>
      );
  }
};

export default UnitDetail;
